import ScalarColorModeToggleButton_vue_vue_type_script_setup_true_lang_default from "./ScalarColorModeToggleButton.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarColorModeToggle/ScalarColorModeToggleButton.vue
var ScalarColorModeToggleButton_default = ScalarColorModeToggleButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarColorModeToggleButton_default as default };

//# sourceMappingURL=ScalarColorModeToggleButton.vue.js.map